import { DeviceStatus } from './device_status';
import { Sensor } from './sensor';
import { UserDevice } from './user-device';

export interface Device {
  userDevice: UserDevice;
  attributes: Attribute[];
  name: string;
  checksum: string;
  createDate: string;
  updatedDate: string;
  dataFromDate: Date;
  externalId: string;
  id: string;
  prefix: string;
  sensors: Sensor[];
  serialNumber: string;
  version: number;
  lat: number;
  long: number;
  location: string;
  province: string;
  status: DeviceStatus;
  hardwareId?: string;
  lastLinkedUserDevice?: UserDevice;
  data: {
    date: Date;
  };
  notifications: [],
  limits: Limit[];
  extraInfo?: { [key: string]: any };
  lastDataDate?: Date | null;
  previousDataDate?: Date | null;
  isDeleted?: boolean;
  deviceMaster: Device | null;
  userDeviceMasterId?:number;

}

export interface Attribute {
  id: string;
  deviceId: string;
  sensorType: number;
  position: number;
  name: string;
  value: number;
  valueString: string;
  deviceSensorId?: string;
}

export interface Limit {
  id: string;
  userId: string;
  deviceSensorId: string;
  name: string;
  property: string;
  value: number;
  maxValue: number;
  minValue: number;
  isVisible: boolean;
  colorCode: string;
  type: LimitType;
  notificationType: NotificationType;
}

export enum LimitType {
  LIMIT = 0,
  RANGE = 1
}

export enum NotificationType {
  NO_NOTIFY = 0,
  NOTIFY_ALWAYS = 1,
  NOTIFY_MORE = 2,
  NOTIFY_LESS = 3
}
/** Cuerpo de PUT /devices/:id cuando solo se cambia la posicion (mover dispositivos del area). */
export type UpdateDeviceLocationPayload = Pick<Device, 'lat' | 'long'>;
